// Credits: borrowed code from fcomb/redux-logger

import { deepCopy } from '@/utils'

const repeat = (str, times) => {
  return (new Array(times + 1)).join(str)
}

const pad = (num, maxLength) => {
  return repeat('0', maxLength - num.toString().length) + num
}

export default function createLogger ({
  collapsed = true,
  filter = (mutation, stateBefore, stateAfter) => true,
  transformer = state => state,
  mutationTransformer = mut => mut,
  logger = console
} = {}) {
  return store => {
    let prevState = deepCopy(store.state)

    store.subscribe((mutation, state) => {
      if (typeof logger === 'undefined') {
        return
      }
      const nextState = deepCopy(state)
      if (filter(mutation, prevState, nextState)) {
        const time = new Date()
        const formattedTime = ` @ ${pad(time.getHours(), 2)}:${pad(time.getMinutes(), 2)}:${pad(time.getSeconds(), 2)}.${pad(time.getMilliseconds(), 3)}`
        const formattedMutation = mutationTransformer(mutation)
        const message = `${mutation.type}${formattedTime}`
        const mutationType = mutation.type
        const mutationTypeLast = mutationType.split('_').pop(-1)
        let color

        switch (mutationTypeLast) {
          case 'FAILURE':
            color = '#ff0000'
            break
          case 'REQUEST':
            color = '#e6a23c'
            break
          case 'RECEIVE':
            color = '#41b883'
            break
          default:
            color = '#03a9f4'
        }

        logger.group(
          (`%c form-builder-web-render-form %c ${message} %c`),
          'background:#35495e; padding: 1px; border-radius: 3px 0 0 3px; color: #fff;',
          `background:${color}; padding: 1px; border-radius: 0 3px 3px 0; color: #fff;`,
          'background:transparent;'
        )

        logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState))
        logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation)
        logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState))

        try {
          logger.groupEnd()
        } catch (e) {
          logger.log('—— log end ——')
        }
      }

      prevState = nextState
    })
  }
}
